class AlgoliaApi {
  static cacheOptions =
    typeof AlgoliaCacheConfig !== "undefined"
      ? { responsesCache: AlgoliaCacheConfig.createResponsesCache() }
      : {};
  static client = algoliasearch(
    "2U4DEZQTYN",
    "ad2b79daf644642d436fed24a2467fde",
    AlgoliaApi.cacheOptions
  );

  // v5 client has no initIndex(); every single-index query goes through client.search()
  static async searchIndex(indexName, { query = "", ...params } = {}) {
    const { results } = await this.client.search({
      requests: [{ indexName, query, ...params }],
    });
    return results[0];
  }

  static async indexSearch({ query = "", facets = ["*"], filters, facetFilters, ...rest } = {}) {
    try {
      const res = await this.searchIndex("shopify_products_search_display", {
        query,
        facets,
        filters,
        facetFilters,
        facetingAfterDistinct: true,
        maxValuesPerFacet: 1000,
        ...rest,
      });
      if (!res.hits.length && !Object.keys(res.facets).length) throw "No products";

      return res;
    } catch (error) {
      console.log(error)
      return null;
    }
  }
}
